"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_TABS = exports.DEFAULT_OPTIONS = exports.LIMIT_USERS_TO_SHOW_COLORS = exports.FULL_CALENDAR_CELL_HEIGHT = void 0;
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
exports.FULL_CALENDAR_CELL_HEIGHT = 40;
exports.LIMIT_USERS_TO_SHOW_COLORS = 2;
exports.DEFAULT_OPTIONS = {
    query: {
        set: {
            setUndefined: false,
        },
    },
};
exports.HEADER_TABS = [
    { value: "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */, label: labels_1.default.SCHEDULER_HEADER_TAB_1 },
    { value: "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */, label: labels_1.default.SCHEDULER_HEADER_TAB_2 },
];
